import { Dispatch } from 'redux';

import { Events } from '../constants/webSocketConsts/events';
import { Product, productsApi } from '../services/api/productsApi';

import { updateListCache } from './updateListCache';

export function handleProductUpdate(
  event: Events,
  items: Product[],
  dispatch: Dispatch<any>,
) {
  const [item] = items;
  dispatch(
    productsApi.util.updateQueryData(
      'getProducts',
      undefined,
      (draft?: Product[]) => {
        updateListCache(event, items, draft);
      },
    ),
  );
  dispatch(
    productsApi.util.updateQueryData(
      'getProductById',
      item.id,
      (draft: Product) => {
        Object.assign(draft, item);
      },
    ),
  );
}
